import { render, staticRenderFns } from "./Striim.vue?vue&type=template&id=7fdb61ca&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdb61ca')) {
      api.createRecord('7fdb61ca', component.options)
    } else {
      api.reload('7fdb61ca', component.options)
    }
    module.hot.accept("./Striim.vue?vue&type=template&id=7fdb61ca&", function () {
      api.rerender('7fdb61ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/partnerIcons/Striim.vue"
export default component.exports